import { useEffect, useRef, useState } from 'react'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../../utils'
import { Box } from '../../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxesPacking, faEdit, faEllipsis, faFlask, faLeaf, faPlantWilt, faPlus, faRecycle, faSeedling, faSprayCan, faWheatAlt } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../../Components/CustomUi/loading'
import Tabs from '../../../../../../Components/Tabs'
import { useScreenSize } from '../../../../../../utils/tsx'

interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_analises: any[]
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  abrirGaveta: Function
  permissao: ItensPerUserLogged
  editarCadastro?: Function
  deletar?: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  tipo_de_analises: number
}

export const TabelaGrupoAnalises: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  listar_analises,
  setOpen,
  abrirGaveta,
  permissao,
  editarCadastro,
  deletar,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  tipo_de_analises,
}) => {
  console.log(tipo_de_analises)
  const [buscarTabela, setBuscarTabela] = useState('')

  const { currentWidth } = useScreenSize({})

  function obterLarguraTabResponsiva(tab_selecionada: string, width: number, dafault: number): number {

    const largurasTabs = {
      'Solo': { md_1536: 115, lg_1920: 170 },
      'Plantas': { md_1536: 115, lg_1920: 170 },
      'Folhas': { md_1536: 115, lg_1920: 170 },
      'Raízes': { md_1536: 115, lg_1920: 170 },
      'Microbiológica': { md_1536: 155, lg_1920: 200 },
      'Fertilizantes': { md_1536: 158, lg_1920: 200 },
      'Corretivos': { md_1536: 130, lg_1920: 150 },
      'Composto orgânico': { md_1536: 195, lg_1920: 200 },
      'Outro': { md_1536: 105, lg_1920: 160 }
    };

    const config = largurasTabs?.[tab_selecionada];

    if (config) {
      if (width < 1500) {
        return config.md_1536;
      } else if (width === 1920) {
        return config.lg_1920;
      }
    }

    return dafault || 125;

  };

  const TABS_CONFIG = [
    { descricao: 'Solo', icone: faWheatAlt, width: obterLarguraTabResponsiva('Solo', currentWidth, 115) },
    { descricao: 'Plantas', icone: faSeedling, width: obterLarguraTabResponsiva('Plantas', currentWidth, 115) },
    { descricao: 'Folhas', icone: faLeaf, width: obterLarguraTabResponsiva('Folhas', currentWidth, 115) },
    { descricao: 'Raízes', icone: faPlantWilt, width: obterLarguraTabResponsiva('Raízes', currentWidth, 115) },
    { descricao: 'Microbiológica', icone: faFlask, width: obterLarguraTabResponsiva('Microbiológica', currentWidth, 155) },
    { descricao: 'Fertilizantes', icone: faBoxesPacking, width: obterLarguraTabResponsiva('Fertilizantes', currentWidth, 158) },
    { descricao: 'Corretivos', icone: faSprayCan, width: obterLarguraTabResponsiva('Corretivos', currentWidth, 135) },
    { descricao: 'Composto orgânico', icone: faRecycle, width: obterLarguraTabResponsiva('Composto orgânico', currentWidth, 195) },
    { descricao: 'Outro', icone: faEllipsis, width: obterLarguraTabResponsiva('Outro', currentWidth, 105) },
  ]


  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <div style={{ height: 'calc(100vh - 880px)', gap: '10px ' }}>
      <Inline alignItems='center'>
        <Input placeholder='Buscar grupo de análises' value={buscarTabela} onChange={setBuscarTabela} />

        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrirGaveta}>
          Novo
        </ButtonCustom>
      </Inline>

      <Tabs
        tabs={TABS_CONFIG}
        selecionado={tab_selecionar_atual}
        onChange={setTab_selecionar_atual}
        useTabWidth

      />

      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 840.5px)' },
          { valor: 'Profundidade', width: '120px' },
          { valor: 'Análises', width: '500px' },
          { valor: 'Ações', width: '220.5px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 280px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_analises ?? [])
            .filter(buscarPatrimonios(buscarTabela))
            .filter((item) => item?.cod_tipo === tipo_de_analises)
            .map(({ cod, cor, nome, profundidade_nome, analises }, index) => {
              return (
                <RowTable key={cod} onDoubleClick={() => editarCadastro(cod)} style={{ height: 'auto', marginTop: index === 0 ? 10 : 0 }}>
                  <RowItem
                    fontSize={13}
                    style={{ alignItems: 'center' }}
                    width={'calc(100% - 835px)'}
                  >
                    <Tag style={{ height: '12px' }} color={cor} key={cod} />
                    {nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'120px'}>
                    {profundidade_nome}
                  </RowItem>

                  <RowItem
                    fontSize={13}
                    width={'500px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {analises?.analises?.map((tag) => {
                      return (
                        <Tag color='green' key={tag.cod} style={{ margin: 5 }}>
                          {tag.nome.toUpperCase()}
                        </Tag>
                      )
                    })}
                  </RowItem>

                  <RowItem width={'215px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading}
                      disabledTrigger={undefined}
                      textButtonTrigger='Excluir'
                      typeButtonTrigger='secondary'
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => editarCadastro(cod)}
                    >
                      Editar
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_analises.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando laboratórios...'
            justifyContent='center'
            height={'100%'}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
